import React, { useEffect, useState } from "react";
import { RenderPaginationButtons } from "../../../Components/Paginations";
import { useLocation, useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { AgentPinChatsListApi, UserListApi } from "../../Api";
import { AxiosResponse } from "axios";
import { useQuery } from "react-query";
import { IoMdArrowRoundBack } from "react-icons/io";

export default function AgentPinChat() {
  const [number, setNumber] = useState<{number: string;}[]>([]);
  const [search, setSearch] = useState("");
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [info, setInfo] = useState<{
    count: number;
    current_page: number;
    limit: number;
    total_page: number;
  }>();
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const { state } = useLocation();

  const { refetch } = useQuery({
    queryKey: [
      "Agent_Pin_Chat_List",
      { search, is_pagination: true, page, campaign_id: state?.campaign_id, agent_id:state?.agent_id },
    ],
    queryFn: AgentPinChatsListApi,
    onSuccess: (resp: AxiosResponse) => {
      setIsLoading(false);
      setIsFirstLoad(false);
      setNumber(resp.data?.Numbers || []);
      setPage(resp.data?.info?.current_page || 1);
      setInfo(resp?.data?.info);
    },
    enabled: false,
  });

  useEffect(() => {
    if (!state?.campaign_id || !state?.agent_id) navigate("/report/sms-conversion-report/campaign-list");
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  useEffect(() => {
    if (isFirstLoad) return;
    setIsLoading(true);
    let debounce = setTimeout(() => {
      refetch();
    }, 300);

    return () => {
      clearTimeout(debounce);
    };
  }, [search]);

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= (info?.total_page || 1)) {
      setPage(page);
    }
  };

  return (
    <div className="container-fluid">
      <div className="card mt-4">
        <div className="card-header bg-white p-3 d-md-flex justify-content-md-between align-items-center">
          <h2 className="w-100 mb-md-2 mb-3">Agent Pin Chats</h2>
          <div className="d-sm-flex justify-content-between align-items-center mb-md-0 mb-3 gap-3">
            <div className="input-group input-group-sm pe-0-3 mb-sm-0 mb-3 search-input">
              <input
                type="search"
                className="form-control float-right height-40px shadow-none"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div className="input-group-append">
                <button
                  type="submit"
                  className="btn border cursor-pointer-none"
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <button
              onClick={() => navigate(-1)}
              className="btn btn-info text-white d-flex align-items-center fw-semibold"
            >
              <IoMdArrowRoundBack /> Back
            </button>
          </div>
        </div>
        <div className="card-body  p-0">
          <div className="table-responsive">
            <table className="table table-hover table-bordered text-nowrap">
              <thead>
                <tr>
                  <th className="ps-3 sr-no">SR No</th>
                  <th>Number</th>
                  <th className="text-center action">Actions</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={4} height={100}>
                      <div className="text-center">
                        <div className="loader"></div>
                      </div>
                    </td>
                  </tr>
                ) : number.length !== 0 ? (
                  number.map((item, i) => (
                    <tr key={i}>
                      <td> {i + 1}</td>
                      <td>{item?.number}</td>
                      <td>
                        <div className="w-100 d-flex justify-content-center">
                          <FaEye
                            className="h4 mb-0 cursor-pointer text-success"
                            onClick={
                              () => 
                                navigate('/report/sms-conversion-report', { state: { number: item?.number, ...state } })
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {info && info.total_page ? (
            <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
              <RenderPaginationButtons
                info={info}
                currentPage={page}
                handlePageChange={handlePageChange}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
